const connector = {
    general: '连接器发生错误：{{errorDescription}}',
    not_found: '找不到可用的 {{type}} 类型的连接器',
    not_enabled: '连接器尚未启用',
    invalid_metadata: '连接器元数据参数错误',
    invalid_config_guard: '连接器配置校验失败',
    unexpected_type: '连接器类型错误',
    invalid_request_parameters: '请求参数错误',
    insufficient_request_parameters: '请求参数缺失',
    invalid_config: '连接器配置错误',
    invalid_certificate: '连接器的证书无效，请确保证书采用隐私增强邮件格式（PEM）编码。',
    invalid_response: '连接器错误响应',
    template_not_found: '无法从连接器配置中找到对应的模板',
    template_not_supported: '连接器不支持此模板类型。',
    rate_limit_exceeded: '触发速率限制。请稍后再试。',
    usage_limit_exceeded: '已达到邮件服务使用上限。',
    not_implemented: '方法 {{method}} 尚未实现',
    social_invalid_access_token: '当前连接器的access_token无效',
    invalid_auth_code: '当前连接器的授权码无效',
    social_invalid_id_token: '当前连接器的id_token无效',
    authorization_failed: '用户授权流程失败',
    social_auth_code_invalid: '无法获取access_token，请检查授权code是否有效',
    more_than_one_sms: '同时存在超过 1 个短信连接器',
    more_than_one_email: '同时存在超过 1 个邮件连接器',
    more_than_one_connector_factory: '找到多个连接器工厂（标识为 {{connectorIds}}），请删除多余项。',
    db_connector_type_mismatch: '数据库中存在一个类型不匹配的连接。',
    not_found_with_connector_id: '找不到指定连接器标识对应的连接器',
    multiple_instances_not_supported: '你选择的连接器不支持创建多实例。',
    invalid_type_for_syncing_profile: '只有社交连接器可以开启用户档案同步。',
    can_not_modify_target: '不可修改连接器的目标（target）字段。',
    should_specify_target: '必须指定目标（target）值。',
    multiple_target_with_same_platform: '同一平台上的多个社交连接器不能使用相同的目标（target）。',
    cannot_overwrite_metadata_for_non_standard_connector: '不可覆盖该连接器的元数据参数。',
    email_connector: {
        bulk_deletion_no_filter: '必须提供至少一个过滤条件才能通过属性执行批量删除。支持的属性有：{{properties, list(type:conjunction)}}。',
    },
    token_storage_not_supported: '此连接器不支持令牌存储。',
};
export default Object.freeze(connector);
